import { connect } from "react-redux";
import { Form, Field } from "react-final-form";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { baseUrl, websiteName },
    content: { websiteTitle },
  },
} = getConfig();

import {
  composeFormValidators,
  isRequired,
  isAlphaNumeric,
  isEmail,
  hasMinLength,
  hasMaxLength,
} from "@lib/validations";
import InputText from "@components/Form/InputText";
import PhoneField, { PHONE_ACCEPTS } from "@components/Form/PhoneField";
import InputCheckbox from "@components/Form/Checkbox";
import Button from "@components/Button";
import { ROMANIA_COUNTRY_CODE, phoneToWire } from "@lib/phoneNumber";
import { userRegister } from "@store/user/actions";
import PasswordComplexity from "@components/PasswordComplexity";

const RegisterForm = (props) => {
  const { hasGrid = false } = props;

  return (
    <Form
      initialValues={{ telephone_country_code: ROMANIA_COUNTRY_CODE }}
      onSubmit={(values) => {
        const wire = phoneToWire(
          values.telephone,
          values.telephone_country_code
        );

        return props.userRegister(
          {
            ...values,
            telephone: wire.telephone,
            telephone_country_code: wire.telephone_country_code,
          },
          props.redirect
        );
      }}
      validate={(values) => {
        const errors = {};
        if (
          values.password &&
          values.password_confirm &&
          values.password !== values.password_confirm
        ) {
          errors.password_confirm = `Trebuie utilizata aceeasi parola.`;
        }
        return errors;
      }}
      render={({ handleSubmit, submitting, values }) => (
        <form
          onSubmit={handleSubmit}
          noValidate={true}
          autoComplete="false"
          className={`text-sm ${hasGrid ? "flex flex-wrap -mx-4" : ""}`}
          data-test="ACCOUNT_REGISTER_FORM"
        >
          <div className={`mb-4 ${hasGrid ? "w-full md:w-1/2 px-4" : ""}`}>
            <Field
              name="first_name"
              label="Prenume"
              component={InputText}
              autoCorrect="off"
              inputClassName="max-w-fulli"
              required
              validate={composeFormValidators(
                isRequired(),
                isAlphaNumeric(),
                hasMaxLength(60),
                hasMinLength(3)
              )}
            />
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full md:w-1/2 px-4" : ""}`}>
            <Field
              name="last_name"
              label="Nume"
              component={InputText}
              autoCorrect="off"
              inputClassName="max-w-fulli"
              required
              validate={composeFormValidators(
                isRequired(),
                isAlphaNumeric(),
                hasMaxLength(60),
                hasMinLength(3)
              )}
            />
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full md:w-1/2 px-4" : ""}`}>
            <Field
              name="email"
              type="email"
              label="Introdu adresa de email"
              component={InputText}
              inputClassName="max-w-fulli"
              autoComplete="off"
              required
              validate={composeFormValidators(
                isRequired(),
                isEmail(),
                hasMaxLength(80),
                hasMinLength(5)
              )}
            />
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full md:w-1/2 px-4" : ""}`}>
            <PhoneField
              id="register_telephone"
              accepts={PHONE_ACCEPTS.FIXED_OR_MOBILE}
              label="Numar de telefon"
              inputClassName="max-w-fulli"
              autoCorrect="off"
              required
            />
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full md:w-1/2 px-4" : ""}`}>
            <Field
              name="password"
              label="Parola"
              type="password"
              autoComplete="new-password"
              inputClassName="max-w-fulli"
              component={InputText}
              required
              validate={composeFormValidators(isRequired(), hasMinLength(6))}
            />

            <div className="mt-[7px]">
              <PasswordComplexity password={values.password} />
            </div>
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full md:w-1/2 px-4" : ""}`}>
            <Field
              name="password_confirm"
              label="Confirma parola"
              type="password"
              autoComplete="new-password"
              inputClassName="max-w-fulli"
              component={InputText}
              required
              // TODO: Add password requirements
              validate={composeFormValidators(isRequired(), hasMinLength(6))}
            />
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full px-4" : ""}`}>
            <Field
              name="agree_terms"
              label={
                <>
                  {`Sunt de acord cu`}
                  {` `}
                  <a
                    href={`${baseUrl}/suport-clienti/informatii-generale-termeni-si-conditii/`}
                    title={`Termenii si conditiile`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-red-brand font-semibold"
                  >
                    {`Termenii si conditiile`}
                  </a>
                  {` `}
                  {`de utilizare a site-ului ${websiteName}.ro`}
                </>
              }
              type="checkbox"
              component={InputCheckbox}
              required
              validate={isRequired()}
            />
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full px-4" : ""}`}>
            <Field
              name="check1"
              component={InputCheckbox}
              label={`Aboneaza-te la newsletter-ul ${websiteTitle} pentru a primi cele mai bune oferte!`}
              type="checkbox"
            />
          </div>

          <div className={`mb-4 ${hasGrid ? "w-full px-4" : ""}`}>
            Informatie - Pentru informatii suplimentare, va rugam sa accesati
            pagina
            {` `}
            <a
              href={`${baseUrl}/protectia-datelor-caracter-personal/pag/`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-brand font-semibold"
            >
              Protectia Datelor cu Caracter Personal
            </a>
            .
          </div>

          <div
            className={`mb-4 lg:mb-0 ${
              hasGrid ? "w-full px-4 text-center" : ""
            }`}
          >
            <Button
              title="Inregistrare"
              display={hasGrid ? "inline" : "block"}
              variant="primary"
              type="submit"
              disabled={submitting}
            />
          </div>
        </form>
      )}
    />
  );
};

export default connect(null, {
  userRegister,
})(RegisterForm);
